import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AuthGuard } from './components/AuthGuard';
import { TopBar } from './components/TopBar';
import { ThemeToggle } from './components/ThemeToggle';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { TriagePage } from './pages/TriagePage';
import { FormulaGraphPage } from './pages/FormulaGraphPage';
import { DashboardPage } from './pages/DashboardPage';
import { CalendarPage } from './pages/CalendarPage';
import { UploadPage } from './pages/UploadPage';

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen bg-paper-50 font-sans text-zinc-900 transition-colors duration-200 dark:bg-study-slate dark:text-zinc-100">
          <TopBar />
          <main>
            <Routes>
              {/* Public route */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected routes */}
              <Route
                path="/"
                element={
                  <AuthGuard>
                    <HomePage />
                  </AuthGuard>
                }
              />
              <Route
                path="/triagem"
                element={
                  <AuthGuard>
                    <TriagePage />
                  </AuthGuard>
                }
              />
              <Route
                path="/grafo"
                element={
                  <AuthGuard>
                    <FormulaGraphPage />
                  </AuthGuard>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <AuthGuard>
                    <DashboardPage />
                  </AuthGuard>
                }
              />
              <Route
                path="/calendario"
                element={
                  <AuthGuard>
                    <CalendarPage />
                  </AuthGuard>
                }
              />
              <Route
                path="/upload"
                element={
                  <AuthGuard>
                    <UploadPage />
                  </AuthGuard>
                }
              />

              {/* Default redirect to / */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <ThemeToggle />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
